import { Component, OnInit } from '@angular/core';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';

import { ChangePasswordComponent } from '../change-password/change-password.component';
import { TranslateService } from '@ngx-translate/core';
import { BranchSelectComponent } from '../branch-select/branch-select.component';
// import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent implements OnInit {

  public compName: string;
  //public branch_name = '';

  branch_list = [];
  show_branch_icon = true;

  changeDialogRef: MatDialogRef<ChangePasswordComponent>;
  branchDialogRef: MatDialogRef<BranchSelectComponent>;

  constructor(public applicationConstants: ApplicationConstants, private router: Router,
    private utils: Utils, public dialog: MatDialog, public translate: TranslateService) {

    this.compName = utils.getParamValue('company_name_' + this.applicationConstants.user_lang);
    this.getMessages(translate);
    //console.log(this.compName);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }

  ngOnInit() {
    //this.router.navigate([{outlets: {primary: 'path' ,sidebar: 'path'}}]);
    //this.router.navigate(['/user_main']);
    //this.branch_name = this.applicationConstants.user_branch_name;

    if (this.applicationConstants.user_info['user_id'] != undefined) {
      let user_id = this.applicationConstants.user_info['user_id'];
      
      //get branch list:
      let query = "SELECT DISTINCT `branch`.`branch_id`, `branch`.* FROM `branch`," +
      " `branch_auth` WHERE `branch_auth`.`status` = '1' AND `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch`.`status` = '1'";

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branch_list = data.data['list'];
        if (this.branch_list.length <= 1)
          this.show_branch_icon = false;
      });
    }
  }

  logOut() {
    this.applicationConstants.user_branch_info = {
      'user_branch_id': '0', 'user_branch_name': '', 'user_branch_name_en': '',
      'user_store_id': '0', 'user_store_name': '', 'user_store_name_en': ''
    };
  
    this.applicationConstants.isLogged = false;
    this.router.navigate(['']);
    //console.log('logOut');
  }

  changePassword() {
    this.changeDialogRef = this.dialog.open(ChangePasswordComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.changeDialogRef
      .afterClosed()
      .subscribe(result => {
      });
  }

  refreshPage() {
    let href = this.router.url;
    let urlParts = href.split("/");

    if (urlParts[1] != 'user_main') {
      let compnentURL = href.substring(href.indexOf('/') + 1);
      console.log(compnentURL);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([compnentURL]); // navigate to same route
      });
    }
  }

  select_branch() {
    if (this.branch_list.length > 1) {
      let dialog_data = this.branch_list;
      this.branchDialogRef = this.dialog.open(BranchSelectComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.branchDialogRef
        .afterClosed()
        .subscribe(result => {
          //this.branch_name = this.applicationConstants.user_branch_info.user_branch_name;
        });
    }
  }

}
